import React from 'react';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

function N18(props) {
    const {
        t,
        i18n,
        time = "",
    } = props;

    return (
        <div>
            <h3>{t("messenger:notifications.N18.title")}</h3>
            <div className="sep-15" />
            <span className="dateTime">{time}</span>
            <div className="sep-10" />
            <div>
                {t("messenger:notifications.N18.msg")}
                <div className="sep-20" />
                <div>
                    <Link to={"/" + i18n.language + "/stepOne"} className="button" >{t("messenger:general.list_a_space")}</Link>
                    &nbsp;&nbsp;
                    <Link to={"/"} className="button" >{t("messenger:general.book_a_space")}</Link>
                </div>
                <div className="sep-10" />
                {t("messenger:general.thank_you_1")}
            </div>
        </div>
    )
}
export default withTranslation()(N18);